import React, { useEffect, useState } from "react";
import PersonalDetails from "./personal/PersonalDetails";
import ActivityDetails from "./activityDetails/ActivityDetails";
import { useLocation } from "react-router-dom";
import { changeActiveTab } from "../../features/slices/studentManagementReducer";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

const StudentDetails = () => {
  const { state } = useLocation();
  const dispatch = useDispatch();
  const { studentActiveTab } = useSelector((state) => {
    return state?.student;
  });
  const handleTab = (val) => {
    dispatch(changeActiveTab(val));
  };

  console.log({ state });
  return (
    <div className="WrapperArea">
      <div className="WrapperBox">
        <div className="Small-Wrapper">
          <div className="NewCommonTabs">
            <ul className="nav nav-tabs">
              <li className="nav-item">
                <a
                  className={`nav-link ${studentActiveTab ? "active" : ""}`}
                  onClick={() => handleTab(true)}
                >
                  Personal Details
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link ${studentActiveTab ? "" : "active"}`}
                  onClick={() => handleTab(false)}
                >
                  Activity Details
                </a>
              </li>
            </ul>
          </div>
          {studentActiveTab ? <PersonalDetails /> : <ActivityDetails />}
        </div>
      </div>
    </div>
  );
};

export default StudentDetails;
